import { render, staticRenderFns } from "./ChartLoader.vue?vue&type=template&id=8d1f0a22&scoped=true&"
import script from "./ChartLoader.vue?vue&type=script&lang=ts&"
export * from "./ChartLoader.vue?vue&type=script&lang=ts&"
import style0 from "./ChartLoader.vue?vue&type=style&index=0&id=8d1f0a22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1f0a22",
  null
  
)

export default component.exports